// Ardor Banner Builder - sticker builder (WholesaleStickers.com) look helper (2026-10-08). Ardor Printing.
// Loaded by sections/ardor-banner-builder-ws.liquid after ardor-banner-builder-v2.js and ardor-banner-app.js.
// Layout only: puts the Ardor logo at the top of the tool rail (like the sticker builder) and tells the CSS how far
// the builder sits below the stuck header so it fills the screen. It does not touch options, prices, proof or cart.
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abw) return;
  root.__abw = true;

  // Ardor logo at the top of the rail (the CSS keeps it first even if more tools are added later)
  function placeLogo() {
    var rail = root.querySelector('.abx-rail'), logo = root.querySelector('[data-abw-logo]');
    if (!rail || !logo) return false;
    if (logo.parentNode !== rail) rail.insertBefore(logo, rail.firstChild);
    logo.hidden = false;
    return true;
  }
  if (!placeLogo()) {
    var tries = 0, timer = setInterval(function () { if (placeLogo() || ++tries > 50) clearInterval(timer); }, 100);
  }

  // like the sticker builder: on computers the builder fills the screen under the announcement bar and header
  var lastTop = '';
  function fit() {
    var top = Math.round(root.getBoundingClientRect().top + window.scrollY);
    if (!(top > 0 && top < 400) || top + 'px' === lastTop) return;
    lastTop = top + 'px';
    root.style.setProperty('--ardor-top', lastTop);
    // the builder sizes its canvases on resize, so let it re-measure the new height
    setTimeout(function () { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }, 0);
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
})();
